module.exports = __webpack_public_path__ + "static/media/teamviewer-logo 1.d95a06e0.png";